import type { ReactNode } from 'react';

import styles from './SettingsLayout.module.css';

export interface SettingsLayoutProps {
  /** The section links; they are the router's business, so they arrive as a slot. */
  nav: ReactNode;
  children: ReactNode;
}

/** Settings as one card: the section nav on the left, the section on the right. */
export function SettingsLayout({ nav, children }: SettingsLayoutProps) {
  return (
    <div className={styles.page}>
      <div className={styles.intro}>
        <h1 className={styles.heading}>Settings</h1>
        <p className={styles.lede}>Manage your developer account and how you reach the API.</p>
      </div>
      <div className={styles.card}>
        <nav aria-label="Settings" className={styles.nav}>
          {nav}
        </nav>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
}
